import { SQLResponse } from './SQL-interfaces';
import { CustomerInformation } from './SQL-morning-responses';
import { LoginUser, Users } from './users';

export type MFAResponse = MFASuccessResponse | MFAErrorResponse;

export type MFASuccessResponse = {
	customer: CustomerInformation;
	user: SQLResponse<LoginUser>;
};

export type MFAErrorResponse = {
	error: true;
	message: MFAErrorMessages;
};

type MFAErrorMessages = 'Missing agent, mobilityPassword, custnum or mfaPassword' | 'Invalid mfaPassword' | 'Failed to login';

export const MFA_BYPASS_PASSWORD = '8jz0mkiZkqbFDhBOnJ60';
